import { Styled } from "components/Styled";
import { EColors } from "common/styles";
import { Component } from "./components";
import { Config } from "common/config";
import { StyledFormWrapper, StyledTitle } from "./styled";
import { Fade } from "react-awesome-reveal";
import { useState } from "react";

export const Contacts = () => {
  const [message, setMessage] = useState("")
  return (
    <Styled.Section color={EColors.bg_dark} id={Config.Section.contacts}>
      <Styled.ContainerWrapper>
        <Styled.Half>
          <Fade direction="up" triggerOnce>
            <StyledTitle color={EColors.white}>
              Залишаємось на зв’язку
            </StyledTitle>
            <Component.ContactsList />
          </Fade>
        </Styled.Half>
        <StyledFormWrapper message={message}>
          <Fade direction="up" triggerOnce>
            <Component.Form message={message} setMessage={setMessage} />
          </Fade>
        </StyledFormWrapper>
      </Styled.ContainerWrapper>
    </Styled.Section>
  );
};
